"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAIN_NAVIGATION = void 0;
var MAIN_NAVIGATION = {
  LINK__ORDERS: 'navigationBar-link-orders',
  LINK__PRODUCTS: 'navigationBar-link-products',
  LINK__OUTLETS: 'navigationBar-link-outlets',
  LINK__REPORTS: 'navigationBar-link-reports',
  LINK__CRM: 'navigationBar-link-crm',
  BUTTON__ACCOUNT_SETTINGS: 'navigationBar-button-settingsDropdown',
  BUTTON__MY_SETTINGS: 'navigationBar-button-mySettings',
  BUTTON__SUPPLIER_SETTINGS: 'navigationBar-button-supplierSettings'
};
exports.MAIN_NAVIGATION = MAIN_NAVIGATION;